import React, { useState } from 'react'
import { ChildrenProps } from '../models/componentModel';
import { createCampaignPayload, createCampaignResponse, getTemplateDetails, getCampaignMessageTypeResponse, runCampaignPayload, campaignContactAssignmentData, updateCampaignPayload, CommonResponseModel, CommonResponseModelWODataArray, responseModel, responseDataModel, campaignContactFilterTypeData, campaignExecutionStatusData, retargetCampaignpayload, pauseCampaignPayload, whatsAppPricingData, archiveCampaignPayload } from '../models/axiosModel';
import agent from '../services/api';

const WhatsappCampaignContext = React.createContext<WhatsappCampaignContextPayload | undefined>(undefined);

export interface WhatsappCampaignContextPayload {
    whatsappCampaignListdData: createCampaignResponse[] | null,
    setWhatsappCampaignListdData: React.Dispatch<React.SetStateAction<createCampaignResponse[] | null>>,
    selectedWhatsAppCampaign: createCampaignResponse | null
    setSelectedWhatsAppCampaign: React.Dispatch<React.SetStateAction<createCampaignResponse | null>>,
    messageTemplateDetail: getTemplateDetails | null,
    setMessageTemplateDetail: React.Dispatch<React.SetStateAction<getTemplateDetails | null>>,
    getWhatsappTemplateDetailsApiCall: (meta_integration_whatsapp_id: number, whatsapp_template_id: number) => Promise<any>,
    whatsAppCampaignMessageTypeData: getCampaignMessageTypeResponse[] | null,
    setWhatsAppCampaignMessageTypeData: React.Dispatch<React.SetStateAction<getCampaignMessageTypeResponse[] | null>>,
    campaignContactStatusPopup: boolean,
    setCampaignContactStatusPopup: React.Dispatch<React.SetStateAction<boolean>>,
    currentContactStatus: campaignContactAssignmentData | null,
    setCurrentContactStatus: React.Dispatch<React.SetStateAction<campaignContactAssignmentData | null>>,

    // Generic States for Retarget Campaign
    campaignContactFilterTypeData: campaignContactFilterTypeData[] | null,
    setCampaignContactFilterTypeData: React.Dispatch<React.SetStateAction<campaignContactFilterTypeData[] | null>>,
    campaignExecutionStatusData: campaignExecutionStatusData[] | null,
    setCampaignExecutionStatusData: React.Dispatch<React.SetStateAction<campaignExecutionStatusData[] | null>>,



    // API's
    getCampaignListApi: () => Promise<CommonResponseModel<createCampaignResponse>>,
    getCampaignDataApi: (campaign_id: number) => Promise<CommonResponseModel<createCampaignResponse>>,
    createCampaignApi: (payload: createCampaignPayload | retargetCampaignpayload) => Promise<CommonResponseModel<createCampaignResponse>>,
    getCampaignMessageTypeApi: () => Promise<CommonResponseModel<getCampaignMessageTypeResponse>>,
    runCampaignApi: (payload: runCampaignPayload) => Promise<responseModel>,
    resumeCampaignApi: (payload: runCampaignPayload) => Promise<responseModel>,
    archiveCampaignApi: (payload: runCampaignPayload) => Promise<responseModel>,
    pauseCampaignApi: (payload: pauseCampaignPayload) => Promise<responseModel>,
    updateCampaignApi: (payload: updateCampaignPayload) => Promise<CommonResponseModel<createCampaignResponse>>,
    deleteCampaignApi: (campaign_id: number) => Promise<CommonResponseModelWODataArray<responseDataModel>>,

    // Generic API's for Retarget Campaign
    getCampaignContactFilterTypeApi: () => Promise<CommonResponseModel<campaignContactFilterTypeData>>,
    getCampaignExecutionStatusApi: () => Promise<CommonResponseModel<campaignExecutionStatusData>>, 

    flagIntegrateBusinessAccountPopup: boolean, 
    setFlagIntegrateBusinessAccountPopup: React.Dispatch<React.SetStateAction<boolean>>,

    whatsAppPricingData: whatsAppPricingData[] | null, 
    setWhatsAppPricingData: React.Dispatch<React.SetStateAction<whatsAppPricingData[] | null>>,
    getWhatsAppPricingApi: () => Promise<CommonResponseModel<whatsAppPricingData>>,
    getMultipleCampaignDataApi: (campaign_ids: string | null, startDateParams: string | null, endDateParams: string | null) => Promise<any>,
}

const WhatsappCampaignProvider = ({ children }: ChildrenProps) => {

    // const [whatsappCampaignListdData, setWhatsappCampaignListdData] = useState<createCampaignResponse[] | null>(null);
    const [whatsappCampaignListdData, setWhatsappCampaignListdData] = useState<createCampaignResponse[] | null>(null);
    const [selectedWhatsAppCampaign, setSelectedWhatsAppCampaign] = useState<createCampaignResponse | null>(null);
    const [messageTemplateDetail, setMessageTemplateDetail] = useState<getTemplateDetails | null>(null);
    const [whatsAppCampaignMessageTypeData, setWhatsAppCampaignMessageTypeData] = useState<getCampaignMessageTypeResponse[] | null>(null);
    const [campaignContactStatusPopup, setCampaignContactStatusPopup] = useState<boolean>(false);
    const [currentContactStatus, setCurrentContactStatus] = useState<campaignContactAssignmentData | null>(null);

    // Generic States for Retarget Campaign
    const [campaignContactFilterTypeData, setCampaignContactFilterTypeData] = useState<campaignContactFilterTypeData[] | null>(null);
    const [campaignExecutionStatusData, setCampaignExecutionStatusData] = useState<campaignExecutionStatusData[] | null>(null);

    const [flagIntegrateBusinessAccountPopup, setFlagIntegrateBusinessAccountPopup] = useState<boolean>(false);

    const [whatsAppPricingData, setWhatsAppPricingData] = useState<whatsAppPricingData[] | null>(null);


    // Campaign API's
    const getCampaignListApi = async (): Promise<CommonResponseModel<createCampaignResponse>> => {
        const res = await agent.getCampaignData.get();
        if (res.status) {
            setWhatsappCampaignListdData(res.data);
        } else {
            setWhatsappCampaignListdData([]);
        }
        return res;
    }

    const getCampaignDataApi = async (campaign_id: number): Promise<CommonResponseModel<createCampaignResponse>> => {
        const res = await agent.getCampaignData.get(campaign_id);
        if (res.status) {
            // setWhatsappCampaignListdData(res.data);
            setSelectedWhatsAppCampaign(res.data[0])
        } else {
            setSelectedWhatsAppCampaign(null)
            // setWhatsappCampaignListdData(null);
            // setWhatsappCampaignListdData(null);
        }
        return res;
    }

    const createCampaignApi = async (payload: createCampaignPayload | retargetCampaignpayload): Promise<CommonResponseModel<createCampaignResponse>> => {
        const res = await agent.createCampaign.post(payload);
        return res;
    }

    const updateCampaignApi = async (payload: updateCampaignPayload): Promise<CommonResponseModel<createCampaignResponse>> => {
        const res = await agent.updateCampaign.put(payload);
        return res;
    }

    const getWhatsappTemplateDetailsApiCall = async (meta_integration_whatsapp_id: number, whatsapp_template_id: number) => {
        const res = await agent.getWhatsappTemplateDetails.get(meta_integration_whatsapp_id, whatsapp_template_id);
        if (res.status) {
            setMessageTemplateDetail(res.data[0]);
        } else {
            setMessageTemplateDetail(null);
        }
        return res;
    }

    const runCampaignApi = async (payload: runCampaignPayload): Promise<responseModel> => {
        const res = await agent.runCampaign.post(payload);
        return res;
    }

    const resumeCampaignApi = async (payload: runCampaignPayload): Promise<responseModel> => {
        const res = await agent.resumeCampaign.post(payload);
        return res;
    }

    const archiveCampaignApi = async (payload: archiveCampaignPayload): Promise<responseModel> => {
        const res = await agent.archiveCampaign.post(payload);
        return res;
    }

    const pauseCampaignApi = async (payload: pauseCampaignPayload): Promise<responseModel> => {
        const res = await agent.pauseCampaign.post(payload);
        return res;
    }

    const deleteCampaignApi = async (campaign_id: number): Promise<CommonResponseModelWODataArray<responseDataModel>> => {
        const res = await agent.deleteCampaign.delete(campaign_id);
        return res;
    }

    // Campaign Message Type API
    const getCampaignMessageTypeApi = async (): Promise<CommonResponseModel<getCampaignMessageTypeResponse>> => {
        const res = await agent.getCampaignMessageType.get();
        if (res.status) {
            setWhatsAppCampaignMessageTypeData(res.data);
        }
        return res;
    }

    // Generic API Call for Retarget Campaign
    const getCampaignContactFilterTypeApi = async (): Promise<CommonResponseModel<campaignContactFilterTypeData>> => {
        const res = await agent.getCampaignContactFilterType.get();
        if (res.status) {
            setCampaignContactFilterTypeData(res.data);
        }
        return res;
    }

    const getCampaignExecutionStatusApi = async (): Promise<CommonResponseModel<campaignExecutionStatusData>> => {
        const res = await agent.getCampaignExecutionStatus.get();
        if (res.status) {
            setCampaignExecutionStatusData(res.data);
        }
        return res;
    }

    const getWhatsAppPricingApi = async () => {
        const res = await agent.getWhatsAppPricing.get();
        if(res.status){
            setWhatsAppPricingData(res.data);
        } else {
            setWhatsAppPricingData(null);
        }
        return res;
    }
    
    const getMultipleCampaignDataApi = async (campaign_ids: string | null, startDateParams: string | null, endDateParams: string | null) => {
        const res = await agent.getMultipleCampaignData.get(campaign_ids, startDateParams, endDateParams);
        return res;
    }

    const payload = {
        whatsappCampaignListdData,
        setWhatsappCampaignListdData,
        selectedWhatsAppCampaign,
        setSelectedWhatsAppCampaign,
        messageTemplateDetail,
        setMessageTemplateDetail,
        getWhatsappTemplateDetailsApiCall,
        whatsAppCampaignMessageTypeData,
        setWhatsAppCampaignMessageTypeData,
        campaignContactStatusPopup,
        setCampaignContactStatusPopup,
        currentContactStatus,
        setCurrentContactStatus,

        // Generic States for Retarget Campaign.
        campaignContactFilterTypeData,
        setCampaignContactFilterTypeData,
        campaignExecutionStatusData,
        setCampaignExecutionStatusData,


        // API's
        getCampaignListApi,
        getCampaignDataApi,
        createCampaignApi,
        getCampaignMessageTypeApi,
        runCampaignApi, 
        resumeCampaignApi, 
        archiveCampaignApi,
        pauseCampaignApi,
        updateCampaignApi,
        deleteCampaignApi,

        // generic API's for Retarget Campaign
        getCampaignContactFilterTypeApi,
        getCampaignExecutionStatusApi,
        flagIntegrateBusinessAccountPopup, 
        setFlagIntegrateBusinessAccountPopup,
        whatsAppPricingData, 
        setWhatsAppPricingData,
        getWhatsAppPricingApi,
        getMultipleCampaignDataApi
    }
    return (
        <WhatsappCampaignContext.Provider value={payload}>
            {children}
        </WhatsappCampaignContext.Provider>
    )
}

export { WhatsappCampaignContext, WhatsappCampaignProvider }
